import { render, staticRenderFns } from "./BatchReportDataTable.vue?vue&type=template&id=58a9c0a8&scoped=true&"
import script from "./BatchReportDataTable.vue?vue&type=script&lang=js&"
export * from "./BatchReportDataTable.vue?vue&type=script&lang=js&"
import style0 from "./BatchReportDataTable.vue?vue&type=style&index=0&id=58a9c0a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a9c0a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a9c0a8')) {
      api.createRecord('58a9c0a8', component.options)
    } else {
      api.reload('58a9c0a8', component.options)
    }
    module.hot.accept("./BatchReportDataTable.vue?vue&type=template&id=58a9c0a8&scoped=true&", function () {
      api.rerender('58a9c0a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/pages/Accounts/BatchReport/BatchReportDataTable.vue"
export default component.exports